import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'table',
    label: 'Table',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
